__webpack_require__.p =(function() {
    const c = [{ 'host': 'https://cloverstatic.com','envPattern': /^https:\/\/sandbox\.dev\.clover\.com$/ },{ 'host': 'https://dev.cloverstatic.com','envPattern': /^https:\/\/.*\.dev\.clover\.com$/ },{ 'host': 'https://dev.cloverstatic.com','envPattern': /^https:\/\/.*\.preprod\.clover\.com$/ },{ 'host': 'https://cloverstatic.com','envPattern': /^https:\/\/[a-zA-Z0-9\-]+(\.[a-z]{2}\.|\.)clover\.com$/ }]; 
    const p = '/web/apps/web-checkout/a5bb7de/';
    for (let i = 0; i < c.length; i++) {
      if (c[i].envPattern.test(window.location.origin)) { return c[i].host + p; }
    }
    return p;
  })()